export default __webpack_public_path__ + "static/media/jest.95bffbbd.png";